//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalesCard from "@/components/SalesCard";
import DiamondsPopover from "@/components/DiamondsPopover";
import { Switch } from "vant";
import Combat from "./Combat.vue";
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
    showDetail: { type: Boolean, default: false },
  },
  components: { SalesCard, "van-switch": Switch, DiamondsPopover, Combat },
  data() {
    return {
      checked: false,
    };
  },
};
